import React, { useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import { useWeb3React } from '@web3-react/core'
import { VectorRightIcon } from 'uikit'
import styled from 'styled-components'
import { usePools, useFetchPublicPoolsData } from 'state/hooks'
import { useTranslation } from 'contexts/Localization'
import PoolsHeader from './PoolsHeader'
import PoolItem from './PoolItem'
import Pagination from '../Pagination'
import usePagination from '../../hooks/usePagination'

const Head = styled.div`
  font-family: Poppins;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  margin-bottom: 12px;
`
const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 45px;
`
const Start = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
`

const PoolsContainer = styled.div`
  background: #002130;
  border-radius: 12px;
`

const Row = styled.div`
  display: row;
  margin-top: 12px;
  margin-bottom: 4px;
`

const Pools: React.FC = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { pools } = usePools(account)

  const openPools = useMemo(() => pools.filter((pool) => !pool.isFinished), [pools])

  useFetchPublicPoolsData()

  const { pages, currentPage, nextPage, prevPage } = usePagination(5, openPools.length)

  const poolsShow = useMemo(() => {
    return openPools.slice((currentPage - 1) * 5, currentPage * 5)
  }, [openPools, currentPage])

  return (
    <>
      <Head>
        <Title>{t('Pools')}</Title>
        <NavLink to="/pools">
          <Start>
            {t('Start Staking')}
            <VectorRightIcon ml={16} fill="#FFFFFF" />
          </Start>
        </NavLink>
      </Head>
      <PoolsContainer>
        <PoolsHeader />
        <Row>
          {poolsShow.map((pool, index) => (
            <PoolItem key={pool.sousId} pool={pool} no={index + 1 + (currentPage - 1) * 5} />
          ))}
        </Row>
        <Pagination current={currentPage} pages={pages} nextPage={nextPage} prevPage={prevPage} />
      </PoolsContainer>
    </>
  )
}

export default Pools
